import * as React from 'react';
import * as styles from './ContentOrganizerPortal.css';
import { ContentOrganizerPortalStore } from './stores';
import { inject, observer } from 'mobx-react';
import { IContentOrganizerCreate } from '../../interfaces/IContentOrganizerCreate';
import { LocalizationService } from '../../services/LocalizationService';
import { Helper } from '../../Helper';
import { IAIcon } from '../icon/Icon';
import ContentOrganizerService from '../../services/ContentOrganizerService';
import { IContentOrganizerSearchResult, IContentOrganizerSearchResultItem } from '../../interfaces/IContentOrganizerSearchResult';
import { Environment } from '../../services/Environment';
import DateTimeService from '../../services/DateTimeService';
import { IASpinner } from '../spinner/Spinner';
import { ConditionalOutput } from '../../services/ConditionalOutput';
import { IACard } from '../card/Card';
import { IACardViewService } from '../messagesCardView/CardView.service';

type GroupedResults = { isCategory: boolean; categoryName: string; item: IContentOrganizerSearchResultItem }[];

export interface IProps {
  contentOrganizerPortalStore?: ContentOrganizerPortalStore;
}

export interface IState {
  searchString: string;
  searchNumberOfResultsToGet: number;
  searchStartFrom: number;
  searchResults: IContentOrganizerSearchResult;
  searchIsLoading: boolean;
  searchDetailsIsLoading: boolean;
  searchResultPopupIsVisible: boolean;
  searchIsDetailedResultsPanelVisible: boolean;
  searchDetailedResults: IContentOrganizerSearchResult;
}

@inject('contentOrganizerPortalStore')
@observer
export class ContentOrganizerPortal extends React.Component<IProps, IState> {

  private MIN_CARD_WIDTH = 212;
  private MAX_CARD_WIDTH = 325;
  private CARD_PADDING = 20;
  private id;

  private readonly dateTimeService: DateTimeService = new DateTimeService();
  private readonly localizationService: LocalizationService = new LocalizationService()
  private readonly emptyResultsValue: IContentOrganizerSearchResult = { resultItems: [], rowCount: 0, totalRows: 0 };
  private inputRef: HTMLInputElement;
  private searchContainerRef: HTMLDivElement;
  private debounceInputTimerId: ReturnType<typeof setTimeout>;
  private wrappedOnBodyClickHandler = e => this.onBodyClickHandler(e);

  constructor(props: IProps) {
    super(props);
    this.state = {
      searchString: "",
      searchNumberOfResultsToGet: 10,
      searchStartFrom: 0,
      searchResults: this.emptyResultsValue,
      searchIsLoading: false,
      searchDetailsIsLoading: false,
      searchResultPopupIsVisible: false,
      searchIsDetailedResultsPanelVisible: false,
      searchDetailedResults: this.emptyResultsValue,
    };
    this.id = Helper.getRandomStringKey();
  }

  public componentDidMount(): void {
    window.addEventListener('resize', () => this.forceUpdate());
    this.forceUpdate();
    setTimeout(() => {
      this.forceUpdate();
    }, 0);
    try {
      var resizeObserver = new ResizeObserver(() => {
        this.forceUpdate();
      });
      resizeObserver.observe(document.getElementById(`IA_CARD_DEMO`));
    } catch {
      this.forceUpdate();
    }
    document.body.addEventListener('click', this.wrappedOnBodyClickHandler);
  }

  public componentWillUnmount(): void {
    document.body.removeEventListener('click', this.wrappedOnBodyClickHandler);
  }

  public render(): JSX.Element {
    let list = [];
    if (this.props.contentOrganizerPortalStore.listInstances && this.props.contentOrganizerPortalStore.listInstances.length > 0) {
      let currentRowNumber = 1;
      let cardsOnPage = 0;
      // Resizing cards
      const containerWidth = document.getElementById(`IA_ContentOrganizerPortal_${this.id}`) != undefined ? document.getElementById(`IA_ContentOrganizerPortal_${this.id}`).offsetWidth : 0;
      let [numberOfCardsPerRow, maxCardWidthAvailable] = new IACardViewService().getNumberOfCardsPerRowAndMaxCardWidthAvailable(containerWidth, this.CARD_PADDING, this.MIN_CARD_WIDTH, this.props.contentOrganizerPortalStore.listInstances.length < this.props.contentOrganizerPortalStore.numberOfCardsPerRow ? this.props.contentOrganizerPortalStore.listInstances.length : this.props.contentOrganizerPortalStore.numberOfCardsPerRow);
      maxCardWidthAvailable = maxCardWidthAvailable > this.MAX_CARD_WIDTH ? this.MAX_CARD_WIDTH : maxCardWidthAvailable;
      //
      this.props.contentOrganizerPortalStore.listInstances.forEach((contentOrganizer: IContentOrganizerCreate, index) => {
        list.push(
          <a
            key={`IA_ContentOrganizerCard_${index}`}
            data-interception="off"
            href={`https://${this.props.contentOrganizerPortalStore.tenant}.sharepoint.com/sites/${contentOrganizer.siteCollection}`}
            target="_blank"
            style={{
              width: window.innerWidth < 667 ? "100%" : maxCardWidthAvailable,
              marginRight: currentRowNumber == numberOfCardsPerRow ? 0 : 20,
              marginBottom: 20,
            }}
          >
            <IACard
              design={this.props.contentOrganizerPortalStore.design}
              onClickOpen={() => { }}
              title={contentOrganizer.title ? contentOrganizer.title : ""}
              teaser={contentOrganizer.description ? contentOrganizer.description : ""}
              cover={{
                imageURL: contentOrganizer.featuredImageUrl ? Helper.getImageUrl(Environment.getEnvironmentForImageAPI(this.props.contentOrganizerPortalStore.environment), this.props.contentOrganizerPortalStore.tenant, this.props.contentOrganizerPortalStore.token, contentOrganizer.featuredImageUrl, "", "StandardLarge", contentOrganizer.featuredImageCropSettings) : "https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/defaultSP.jpg"
              }}
              width={window.innerWidth < 667 ? window.innerWidth - 56 : maxCardWidthAvailable}
              styles={{
                width: window.innerWidth < 667 ? "100%" : maxCardWidthAvailable,
              }}
            />
          </a>
        );
        cardsOnPage++;
        if (currentRowNumber == numberOfCardsPerRow || cardsOnPage == this.props.contentOrganizerPortalStore.numberOfCardsPerRow) {
          currentRowNumber = 1;
        } else {
          currentRowNumber++;
        }
        if (cardsOnPage == this.props.contentOrganizerPortalStore.numberOfCardsPerRow) {
          cardsOnPage = 0;
        }
      });
    } else {
      for (let i = 0; i < 10; i++) {
        list.push(
          <div
          >
            <div className={styles.skeletonImg}>
            </div>
            <div className={styles.IPortal_ButtonContent}>
              <div
                style={{
                  textAlign: "left",
                  marginRight: "24px"
                }}>
                <span className={styles.IPortal_Headline}></span>
                <p></p>
              </div>
            </div>
          </div>);
      }
    }
    let links;
    links = (<div>
      <div className={styles.IPortal_TemplateTitle}>
        {this.props.contentOrganizerPortalStore.title}
      </div>
      <div className={styles.IPortal_Result}>
        {list}
      </div>
    </div>);
    let panel = (
      <div
        id={`IA_ContentOrganizerPortal_${this.id}`}
        className={styles.IPortal_Panel}
      >
        <div>
          <div
            className={styles.search}
            ref={el => this.searchContainerRef = el}>
            <div className={styles.searchInputWrapper}>
              <button
                onClick={() => {
                  this.inputRef.focus();
                }}>
                <IAIcon title="Search" color="" size={24} />
              </button>
              <input type="text" className={styles.input}
                ref={input => this.inputRef = input}
                readOnly={!this.props.contentOrganizerPortalStore.listInstances?.length}
                placeholder={this.props.contentOrganizerPortalStore.searchPlaceholder}
                onChange={(e) => {
                  var currentSearchValue = e.target.value;
                  this.setState({ searchString: currentSearchValue, searchIsLoading: true, searchResultPopupIsVisible: true, }, () => {
                    clearTimeout(this.debounceInputTimerId);
                    if (!currentSearchValue) {
                      this.setState({ searchResultPopupIsVisible: false, });
                      return;
                    }
                    this.debounceInputTimerId = setTimeout(() => {
                      ContentOrganizerService.searchInContentOrganizers(
                        this.props.contentOrganizerPortalStore.environment,
                        this.props.contentOrganizerPortalStore.token,
                        this.props.contentOrganizerPortalStore.tenant,
                        this.props.contentOrganizerPortalStore.listInstances.map(x => x.siteCollection),
                        currentSearchValue,
                        this.state.searchNumberOfResultsToGet,
                        0,
                      )
                        .then(results => {
                          if (this.state.searchString === currentSearchValue) {
                            this.setState({ searchResults: results, searchIsLoading: false, searchResultPopupIsVisible: true });
                          }
                        })
                    }, 500);
                  })
                }}
                onKeyPress={event => {
                  if (event.key === 'Enter' && !this.state.searchIsLoading) {
                    this.setState({ searchResultPopupIsVisible: false, searchIsDetailedResultsPanelVisible: true, searchDetailedResults: this.state.searchResults, searchStartFrom: 0, });
                  }
                }}
              />
              <button
                style={{ display: this.state.searchString ? "flex" : "none" }}
                onClick={() => {
                  this.inputRef.value = '';
                  this.setState({ searchString: '', searchResults: this.emptyResultsValue, searchIsLoading: false, searchResultPopupIsVisible: false, searchIsDetailedResultsPanelVisible: false, searchDetailedResults: this.emptyResultsValue, });
                }}>
                <IAIcon title="Close" color="" size={24} />
              </button>
            </div>
            <div className={styles.results} style={{ display: this.state.searchResultPopupIsVisible ? "flex" : "none" }}>
              {this.state.searchIsLoading
                ? <IASpinner />
                : <></>
              }
              {!this.state.searchIsLoading
                ? this.groupPopupResults(this.state.searchResults.resultItems).map(x =>
                  x.isCategory
                    ? <div className={[styles.resultItem, styles.categoryItem].join(' ')}>
                      {x.categoryName}
                    </div>
                    : <div className={styles.resultItem}>
                      <a href={x.item.path}
                        className={styles.resultItemAnchor}
                        target="_blank"
                        data-interception="off">
                        <div className={styles.iconOrLetter}>
                          {x.item.contentClass === "STS_Site"
                            ? <span className={styles.letter} style={{ backgroundColor: "#ccc" }}>{x.item.title[0].toUpperCase()}</span>
                            : <IAIcon title={this.getImageForItem(x.item)} color="" size={24} />
                          }
                        </div>
                        <ul className={styles.text}>
                          <li className={styles.title}>{x.item.title}</li>
                          <li className={styles.category} style={{ display: x.item.contentClass === "STS_Site" ? "none" : "block" }}>{x.item.siteName.substr(x.item.siteName.lastIndexOf('/') + 1)}</li>
                          <li className={styles.date}>
                            {this.localizationService.strings.ContentOrganizerPortal_LastUpdated}
                            {this.dateTimeService.ConvertToDDMMYYYY(x.item.lastModifiedTime)}
                          </li>
                        </ul>
                      </a>
                    </div>
                )
                : <></>
              }
              {!this.state.searchIsLoading && !this.state.searchResults.resultItems.length
                ? <div className={styles.noResults}>
                  {this.localizationService.strings.ContentOrganizerPortal_NoResults}
                </div>
                : <></>
              }
              {!this.state.searchIsLoading && this.state.searchResults.resultItems.length
                && this.state.searchResults.rowCount < this.state.searchResults.totalRows
                ? <a className={styles.showMoreResults}
                  onClick={() => {
                    this.setState({ searchIsLoading: false, searchResultPopupIsVisible: false, searchIsDetailedResultsPanelVisible: true, searchDetailedResults: this.state.searchResults, searchStartFrom: 0, });
                  }}>
                  {this.localizationService.strings.ContentOrganizerPortal_ShowMoreResults}
                </a>
                : <></>
              }
            </div>
            <div className={styles.detailedResults} style={{ display: this.state.searchIsDetailedResultsPanelVisible ? "flex" : "none" }}>
              {this.state.searchDetailedResults.resultItems.map(x =>
                <div className={styles.resultItem}>
                  <div className={styles.iconOrLetter}>
                    {x.contentClass === "STS_Site"
                      ? <span className={styles.letter} style={{ backgroundColor: "#ccc" }}>{x.title[0].toUpperCase()}</span>
                      : <IAIcon title={this.getImageForItem(x)} color="" size={24} />
                    }
                  </div>
                  <ul className={styles.text}>
                    <li className={styles.title}>
                      <a href={x.path}
                        className={styles.resultItemAnchor}
                        target="_blank"
                        data-interception="off">{x.title}</a>
                    </li>
                    <li className={styles.category} style={{ display: x.contentClass === "STS_Site" ? "none" : "block" }}>{x.siteName.substr(x.siteName.lastIndexOf('/') + 1)}</li>
                    <li className={styles.date}>
                      {this.localizationService.strings.ContentOrganizerPortal_LastUpdated}
                      {this.dateTimeService.ConvertToDDMMYYYY(x.lastModifiedTime)}
                    </li>
                  </ul>
                </div>
              )
              }
              {this.state.searchDetailedResults.resultItems.length > 0 ?
                <div className={styles.paging}
                  style={{
                    display:
                      this.state.searchStartFrom - this.state.searchNumberOfResultsToGet < 0
                        && this.state.searchStartFrom + this.state.searchNumberOfResultsToGet > this.state.searchDetailedResults.totalRows
                        ? "none"
                        : "",
                  }}>
                  <a className={
                    new ConditionalOutput("")
                      .OnCondition(this.state.searchStartFrom - this.state.searchNumberOfResultsToGet < 0, styles.disabled)
                      .AsClassName()
                  }
                    href="#"
                    data-interception="off"
                    onClick={() => {
                      this.setState({ searchStartFrom: this.state.searchStartFrom - this.state.searchNumberOfResultsToGet, searchDetailsIsLoading: true, }, () => {
                        ContentOrganizerService.searchInContentOrganizers(
                          this.props.contentOrganizerPortalStore.environment,
                          this.props.contentOrganizerPortalStore.token,
                          this.props.contentOrganizerPortalStore.tenant,
                          this.props.contentOrganizerPortalStore.listInstances.map(x => x.siteCollection),
                          this.state.searchString,
                          this.state.searchNumberOfResultsToGet,
                          this.state.searchStartFrom,
                        )
                          .then(results => {
                            this.setState({ searchDetailedResults: results, searchDetailsIsLoading: false, searchResultPopupIsVisible: false });
                          })
                      })
                    }}
                  >
                    {this.localizationService.strings.ContentOrganizerPortal_PreviousPage}
                  </a>
                  <a className={
                    new ConditionalOutput("")
                      .OnCondition(this.state.searchStartFrom + this.state.searchNumberOfResultsToGet > this.state.searchDetailedResults.totalRows, styles.disabled)
                      .AsClassName()
                  }
                    href="#"
                    data-interception="off"
                    onClick={() => {
                      this.setState({ searchStartFrom: this.state.searchStartFrom + this.state.searchNumberOfResultsToGet, searchDetailsIsLoading: true, }, () => {
                        ContentOrganizerService.searchInContentOrganizers(
                          this.props.contentOrganizerPortalStore.environment,
                          this.props.contentOrganizerPortalStore.token,
                          this.props.contentOrganizerPortalStore.tenant,
                          this.props.contentOrganizerPortalStore.listInstances.map(x => x.siteCollection),
                          this.state.searchString,
                          this.state.searchNumberOfResultsToGet,
                          this.state.searchStartFrom,
                        )
                          .then(results => {
                            this.setState({ searchDetailedResults: results, searchDetailsIsLoading: false, searchResultPopupIsVisible: false });
                          })
                      })
                    }}
                  >
                    {this.localizationService.strings.ContentOrganizerPortal_NextPage}
                  </a>
                  <div className={styles.loader}
                    style={{
                      display: this.state.searchDetailsIsLoading ? "block" : "none"
                    }}>
                    <IASpinner style={{
                      margin: "0"
                    }} />
                  </div>
                </div>
                : <></>
              }
              {!this.state.searchDetailedResults.resultItems.length
                ? <div className={styles.noResults}>
                  {this.localizationService.strings.ContentOrganizerPortal_NoResults}
                </div>
                : <></>
              }
            </div>
          </div>
          <div
            className={["IA_OnFocusOutline_outer"].join(" ")}
          >
            {links}
          </div>
        </div>
      </div>);
    return (
      <div>
        {panel}
      </div>
    );
  }

  public onBodyClickHandler(event): void {
    if (this.searchContainerRef && !this.searchContainerRef.contains(event.target) && !this.state.searchIsLoading) {
      this.setState({ searchResultPopupIsVisible: false });
    }
  }
  
  private getImageForItem(item: IContentOrganizerSearchResultItem): string {
    switch (item.extension.toLocaleLowerCase()) {
      case 'aspx': return 'SharePoint Page';
      default:
        return Helper.getFileIconFromExtension(`.${item.extension}`).icon;
    }
  }

  private groupPopupResults(items: IContentOrganizerSearchResultItem[]): GroupedResults {
    var categories = items.reduce<{ [contentClass: string]: string }>((x, a) => {
      var category = this.contentClassToCategory(a);
      switch (category) {
        case "sites":
          x["sites"] = this.localizationService.strings.ContentOrganizerPortal_CategorySites;
          break;
        case "pages":
          x["pages"] = this.localizationService.strings.ContentOrganizerPortal_CategoryPages;
          break;
        case "files":
          x["files"] = this.localizationService.strings.ContentOrganizerPortal_CategoryFiles;
          break;
        default:
          x["assets"] = this.localizationService.strings.ContentOrganizerPortal_CategoryAssets;
          break;
      }
      return x;
    }, {});

    var groupedItems = items
      .reduce<{ [category: string]: IContentOrganizerSearchResultItem[] }>((x, a) => {
        var category = this.contentClassToCategory(a);
        x[category] = x[category] || [];
        x[category].push(a);
        return x;
      }, Object.create(null));

    return Object.keys(categories)
      .reduce<GroupedResults>((x, a) => {
        x.push({
          isCategory: true,
          categoryName: categories[a],
          item: undefined,
        });
        groupedItems[a].forEach(element => {
          x.push({
            isCategory: false,
            categoryName: undefined,
            item: element,
          });
        });
        return x;
      }, [])
  }

  private contentClassToCategory(item: IContentOrganizerSearchResultItem) {
    switch (item.contentClass) {
      case "STS_Site":
        return "sites";
      case "STS_ListItem_WebPageLibrary":
        return "pages";
      default:
        switch (item.extension) {
          case "jpg":
          case "png":
          case "gif":
          case "bmp":
          case "mp4":
          case "mkv":
          case "avi":
          case "wmv":
          case "m4v":
            return "assets";
          default:
            return "files";
        }
    }
  }
}